import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {change, Field} from 'redux-form';
import {connect} from "react-redux";
import {compose} from "recompose";
import {
    SelectInput,
    TextInput
} from 'admin-on-rest';
import {filterStyles} from '../shared/styles-filter';

/**
 * Date Range Type selection for Schedule Report form
 *
 */
class ScheduleReportFormDaysBackInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            back_num: (props.formValues && props.formValues.back_num) ? props.formValues.back_num : 1,
            back_type: 'days'
        };
        this.handleFieldUpdate = this.handleFieldUpdate.bind(this);
    }

    // Store and notify form of field updates
    handleFieldUpdate(field, event, index) {
        let fieldValue = (index) ? index : null;
        if (field === 'back_num') {
            fieldValue = parseInt(fieldValue, 10);
        }
        if (fieldValue && !isNaN(fieldValue)) {
            this.limitRange(field, fieldValue);
        } else {
            if (field === 'back_num') {
                // Allow empty field for Days Back
                this.setState({
                    back_num: ''
                }, () => {
                    if (typeof this.props.formName === 'string') {
                        this.props.dispatch(change(this.props.formName, 'back_num', fieldValue));
                    }
                });
            }
        }
    }

    // Limit Days back to 1 year for Relative Range Type
    limitRange = (field, value) => {
        let back_num = (field === 'back_num') ? parseInt(value, 10) : parseInt(this.state.back_num, 10);
        let back_type = (field === 'back_type') ? value : this.state.back_type;
        if (back_num) {
            back_num = Math.trunc(back_num);
        }
        let newback_num = -1;
        if (back_type === 'months' && back_num > 12) {
            newback_num = 12;
        }
        if (back_type === 'weeks' && back_num > 52) {
            newback_num = 52;
        }
        if ((back_type === 'days' || !back_type) && back_num > 365) {
            newback_num = 365;
        }
        const numValue = (newback_num > 0) ? newback_num : back_num;
        this.setState({
            back_num: numValue,
            back_type: back_type
        }, () => {
            if (typeof this.props.formName === 'string') {
                this.props.dispatch(change(this.props.formName, 'back_num', numValue));
                this.props.dispatch(change(this.props.formName, 'back_type', back_type));
            }
        });
    };

    render() {
        const {
            back_num,
        } = this.state;

        const {
            formValues
        } = this.props;

        return (
            <span className="list-filter">
                <span style={filterStyles.inlineText}>Report Date to:</span>
                <Field
                    name="back_num"
                    component={TextInput}
                    label="Number"
                    value={back_num}
                    options={{
                        inputMode: 'numeric',
                        pattern: '[0-9]*',
                        step: 1,
                        min: 1,
                        max: 365,
                        value: back_num
                    }}
                    onChange={(e, i, v) => this.handleFieldUpdate('back_num', e, i, v)}
                    elStyle={{...filterStyles.inline, ...filterStyles.selectInputSmall}}
                />
                <Field
                    name="back_type"
                    label="of Type"
                    placeholder="Days Before"
                    component={SelectInput}
                    choices={[
                        {id: 'days', name: 'Days Before'},
                        {id: 'weeks', name: 'Weeks Before'},
                        {id: 'months', name: 'Months Before'},
                    ]}
                    value={formValues.back_type}
                    onChange={(e, i, v) => this.handleFieldUpdate('back_type', e, i, v)}
                    elStyle={{...filterStyles.selectInputMedium, ...filterStyles.inline}}
                />
            </span>
        );
    }
}

const mapStateToProps = (state) => {
    let form = state.form['record-form'];
    if (form && form.values) {
        return {
            formValues: form.values
        }
    }
    return {}
};

ScheduleReportFormDaysBackInput.propTypes = {
    formName: PropTypes.string,
    formValues: PropTypes.object
};

const enhance = compose(
    connect(mapStateToProps)
);
/*
,
    reduxForm({
        form: 'record-form',
        enableReinitialize: true,
    })
 */

export default enhance(ScheduleReportFormDaysBackInput);


// WEBPACK FOOTER //
// ./src/Fuse/components/ScheduleReportFormDaysBackInput.js